import { apiSlice } from "src/services/ApiSlice";
import { setAccessToken, setRefreshToken } from "src/redux/slices/AuthSlice";
import { authTokenKeyName, refreshTokenKeyName } from "./configs/authConfig";

const apiSliceType: any = apiSlice;

// for signing out
export const singnOut = () => {
  localStorage.removeItem(authTokenKeyName);
  localStorage.removeItem(refreshTokenKeyName);
  localStorage.removeItem("userData");
  window.location.replace("/");
};

export const authMiddleware = (store: any) => (next: any) => (action: any) => {
  const result = next(action);
  const token = localStorage.getItem(authTokenKeyName);
  const refreshToken = localStorage.getItem(refreshTokenKeyName);


  const userData = localStorage.getItem("userData");

  if (result.error && result?.payload?.status === 401) {
    store
      .dispatch(
        apiSliceType?.endpoints?.getAccessToken?.initiate({
          refreshToken: localStorage.getItem(refreshTokenKeyName) || "",
        })
      )
      .then((res: any) => {
        if (
          res?.error &&
          (res?.error?.status === 401 || res?.error?.status === 500 || !refreshToken)
        ) {
          singnOut();
        } else {
          store.dispatch(setAccessToken(res?.data?.data?.token));
          store.dispatch(setRefreshToken(res?.data?.data?.refreshToken));
          localStorage.setItem(authTokenKeyName, res.data?.data?.token);
          localStorage.setItem(refreshTokenKeyName, res.data?.data?.refreshToken);

        }
      });
  } else if (token && refreshToken && !userData) {
    singnOut();
  }
  return result;
};
